import { render, staticRenderFns } from "./ProjectPromoItem.vue?vue&type=template&id=2b40bb52"
import script from "./ProjectPromoItem.vue?vue&type=script&lang=js"
export * from "./ProjectPromoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports